import { Backdrop, Card, CircularProgress, Stack, Typography, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { toast } from 'react-toastify';
import { tokenService } from 'src/services';
import Services from 'src/services/Services';

export default function CdekOperations() {
    const [iframeUrl, setIframeUrl] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCdekLink = async () => {
            try {
                // 1. Kullanıcı ve PointID bilgisini al
                const user = tokenService.getUser();
                const pointID = user?.firstResponsibleOffice?.id;

                if (!pointID) {
                    toast.error("Sorumlu ofis bilgisi (Point ID) bulunamadı.");
                    setLoading(false);
                    return;
                }

                // 2. Servis isteği at
                const res = await Services.GetCdekLink(pointID);

                // 3. Response kontrolü ve linkin set edilmesi
                if (res.data.status && res.data.result?.link) {
                    setIframeUrl(res.data.result.link);
                } else {
                    toast.error(res.data.message || "CDEK bağlantısı alınamadı.");
                }
            } catch (error) {
                console.error("CDEK Link Error:", error);
                toast.error("Bağlantı sırasında bir hata oluştu.");
            } finally {
                setLoading(false);
            }
        };

        fetchCdekLink();
    }, []);

    return (
        <>
            <Helmet>
                <title> CDEK Operasyonları </title>
            </Helmet>

            <Stack style={{ paddingInline: '25px', height: '100%' }}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={3}
                >
                    <Typography variant="h4" gutterBottom>
                        CDEK Operasyonları
                    </Typography>
                </Stack>

                <Card sx={{ height: '80vh', position: 'relative', overflow: 'hidden' }}>
                    {loading ? (
                        <Backdrop
                            sx={{ color: '#fff', zIndex: 10, position: 'absolute' }}
                            open={loading}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    ) : iframeUrl ? (
                        <Box sx={{ width: '100%', height: '100%' }}>
                            <iframe
                                src={iframeUrl}
                                title="CDEK Operations Interface"
                                width="100%"
                                height="100%"
                                style={{ border: 'none' }}
                                allow="clipboard-read; clipboard-write"
                            />
                        </Box>
                    ) : (
                        <Stack 
                            alignItems="center" 
                            justifyContent="center" 
                            sx={{ height: '100%' }}
                        >
                            <Typography variant="body1" color="text.secondary">
                                Görüntülenecek içerik bulunamadı.
                            </Typography>
                        </Stack>
                    )}
                </Card>
            </Stack>
        </>
    );
}